import { gql } from 'graphql-request';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useDeletePracticeTest = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async (testId?: number) => client.request(
    gql`
    mutation AdminDeleteTest($testId: Float!) {
      adminDeleteTest(testId: $testId) {
        message
      }
    }
    `,
    {
      testId: testId || undefined
    }
  ).catch((error) => toast(error.response.errors[0].message)), {
    onSuccess: (data: any) => { toast(data?.deletePost?.message); }
  });
  return Mutation;
};
